import React, { useMemo } from 'react'
import { Form } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import { getEligibleAgencies, isSectorDisabled } from '../../../../utils/sectorUtils'
import AgencyItem from './AgencyItem'

const SectorItem = ({ sector, level, type, expandedItems, selectedItems, onToggleExpand, onSelectionChange, associatedAgencies = [] }) => {
  const eligibleAgencies = useMemo(() => getEligibleAgencies(sector.agencies, type, associatedAgencies), [sector.agencies, type, associatedAgencies])

  const isAllSelected = useMemo(
    () => eligibleAgencies.length > 0 && eligibleAgencies.every((agency) => selectedItems.includes(agency.id)),
    [eligibleAgencies, selectedItems],
  )

  const handleSectorSelect = () => {
    const sectorAgencyIds = eligibleAgencies.map((agency) => agency.id)

    const newSelectedItems = isAllSelected ? selectedItems.filter((id) => !sectorAgencyIds.includes(id)) : [...selectedItems, ...sectorAgencyIds]

    onSelectionChange(newSelectedItems)
  }

  const isExpanded = useMemo(() => expandedItems.includes(sector.id), [expandedItems, sector.id])

  const isDisabled = useMemo(() => isSectorDisabled(type, sector.agencies, associatedAgencies), [type, sector.agencies, associatedAgencies])

  return (
    <div className={`sector-item agency-menu-item agency-menu-level-${level} ${isDisabled ? 'disabled-item' : ''}`}>
      <div className="d-flex justify-content-between p-3 bg-white rounded shadow-sm">
        {!isDisabled && (
          <Form.Check
            type="checkbox"
            checked={isAllSelected}
            onChange={handleSectorSelect}
            label={`${sector.label} (${eligibleAgencies.length})`}
            key={`sector-${type}-${sector.code}`}
            id={`sector-${type}-${sector.code}`}
          />
        )}
        {isDisabled && <span>{`${sector.label} (${eligibleAgencies.length})`}</span>}
        <FontAwesome className="rct-icon" name={isExpanded ? 'chevron-down' : 'chevron-right'} onClick={() => onToggleExpand(sector.id)} />
      </div>
      {isExpanded && (
        <div className="mt-2">
          {sector.agencies.map((agency) => (
            <AgencyItem
              key={agency.id}
              agency={agency}
              level={level + 1}
              type={type}
              selectedItems={selectedItems}
              onSelectionChange={onSelectionChange}
              associatedAgencies={associatedAgencies}
            />
          ))}
        </div>
      )}
    </div>
  )
}

export default React.memo(SectorItem)
